import { createContext, ReactNode, useContext } from 'react';

import type { FormatPresetData } from '../helpers';

export type EditFormatPresetOptions = {
  onApply?: (format: string, formatLanguage?: string) => void;
};

type FormatPresetsContextValue = {
  formatPresets: FormatPresetData[];
  onSaveFormatPreset?: (preset: Omit<FormatPresetData, 'id'>) => void;
  onEditFormatPreset?: (preset: FormatPresetData, options?: EditFormatPresetOptions) => void;
  onRemoveFormatPreset?: (id: string) => void;
};

const FormatPresetsContext = createContext<FormatPresetsContextValue>({
  formatPresets: [],
});

export const useFormatPresets = () => useContext(FormatPresetsContext);

type FormatPresetsProviderProps = FormatPresetsContextValue & {
  children: ReactNode;
};

export const FormatPresetsProvider = ({
  children,
  formatPresets,
  onSaveFormatPreset,
  onEditFormatPreset,
  onRemoveFormatPreset,
}: FormatPresetsProviderProps) => (
  <FormatPresetsContext.Provider
    value={{ formatPresets, onSaveFormatPreset, onEditFormatPreset, onRemoveFormatPreset }}
  >
    {children}
  </FormatPresetsContext.Provider>
);
